const MS_PER_DAY = 24 * 60 * 60 * 1000;
const DEFAULT_ALL_DAY_TIME_ZONE = 'UTC';
const datePartsFormatters = new Map();
export function getAllDayTimeZone(timeZone) {
  const candidate = timeZone == null ? void 0 : timeZone.trim();
  if (!candidate) {
    return DEFAULT_ALL_DAY_TIME_ZONE;
  }
  try {
    new Intl.DateTimeFormat('en-US', {
      timeZone: candidate
    });
    return candidate;
  } catch {
    return DEFAULT_ALL_DAY_TIME_ZONE;
  }
}
const getDatePartsFormatter = timeZone => {
  const allDayTimeZone = getAllDayTimeZone(timeZone);
  const cachedFormatter = datePartsFormatters.get(allDayTimeZone);
  if (cachedFormatter) {
    return cachedFormatter;
  }
  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone: allDayTimeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });
  datePartsFormatters.set(allDayTimeZone, formatter);
  return formatter;
};
const getUTCCalendarDateParts = date => ({
  year: date.getUTCFullYear(),
  month: date.getUTCMonth() + 1,
  day: date.getUTCDate()
});
const getCalendarDatePartsInTimeZone = (date, timeZone) => {
  const parsedDate = new Date(date);
  if (Number.isNaN(parsedDate.getTime())) {
    throw new Error(`Invalid all-day date: ${String(date)}`);
  }
  const parts = getDatePartsFormatter(timeZone).formatToParts(parsedDate);
  const getPart = type => {
    var _parts$find;
    const value = Number((_parts$find = parts.find(part => part.type === type)) == null ? void 0 : _parts$find.value);
    return Number.isFinite(value) ? value : undefined;
  };
  const calendarDateParts = {
    year: getPart('year'),
    month: getPart('month'),
    day: getPart('day')
  };
  return Object.values(calendarDateParts).every(value => typeof value === 'number') ? calendarDateParts : getUTCCalendarDateParts(parsedDate);
};
const getUTCDateIndex = _ref => {
  let {
    year,
    month,
    day
  } = _ref;
  return Date.UTC(year, month - 1, day) / MS_PER_DAY;
};
export function allDayCalendarDays(startDate, endDate) {
  const start = new Date(startDate);
  const end = new Date(endDate);
  const startUTC = Date.UTC(start.getUTCFullYear(), start.getUTCMonth(), start.getUTCDate());
  const endUTC = Date.UTC(end.getUTCFullYear(), end.getUTCMonth(), end.getUTCDate());
  return Math.max(1, Math.round((endUTC - startUTC) / MS_PER_DAY));
}
export function allDayInclusiveEndUTC(endDate) {
  const end = new Date(endDate);
  return new Date(Date.UTC(end.getUTCFullYear(), end.getUTCMonth(), end.getUTCDate() - 1));
}
export function allDayDateToUTCMidnight(dateStr) {
  const [year, month, day] = dateStr.substring(0, 10).split('-').map(Number);
  return Date.UTC(year, month - 1, day);
}
export function allDayCalendarDaysInTimeZone(startDate, endDate, timeZone) {
  const start = getCalendarDatePartsInTimeZone(startDate, timeZone);
  const end = getCalendarDatePartsInTimeZone(endDate, timeZone);
  return Math.max(1, Math.round(getUTCDateIndex(end) - getUTCDateIndex(start)));
}
export function allDayExclusiveEndToInclusiveInstant(endDate) {
  // All-day end dates are exclusive; date-only formatting uses the previous instant.
  return new Date(new Date(endDate).getTime() - 1);
}
//# sourceMappingURL=index.js.map